export enum ResponseCodes {
  NOT_FOUND = 404,
  OK = 200,
  FORBIDDEN = 403,
  ERROR = 500,
  BAD_REQUEST = 400,
  CREATED = 201
}
